import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'whatsappFormatNumber'
})
export class WhatsappFormatNumberPipe implements PipeTransform {

  transform(value: string): unknown {
    if (!value) return '';
    return value.replace("+", "")
  }
}